<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="alerts"
      class="elevation-1"
      :loading="loading"
      :items-per-page="-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Upozornění</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer><v-dialog
          v-model="dialog"
          max-width="650"
        >
          <template
            v-slot:activator="{ on, attrs }"
          >
            <v-btn
              @click="editedItem = defaultItem"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              Přidat upozornění
            </v-btn>
          </template>
          <AlertsForm
            :item="editedItem"
            v-if="dialog"
            @data-saved="getAlerts"
          >
          </AlertsForm>
        </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editAlert(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="toggleActive(item)"
        >
          {{item.active ? 'mdi-sleep' : 'mdi-sleep-off'}}
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getAlerts">Reset</v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import AlertsForm from '../../forms/admin/AlertsForm'
export default {
  name: 'Alerts',
  components: { AlertsForm },
  data () {
    return {
      loading: true,
      dialog: false,
      editedItem: {},
      defaultItem: {
        id: null,
        name: null,
        active: false,
        type: null
      },
      headers: [
        { text: 'Název', value: 'text' },
        { text: 'Typ upozornění', value: 'typeStr' },
        { text: 'Aktivní', value: 'activeStr' },
        { text: 'Akce', value: 'actions' }
      ],
      alerts: []
    }
  },
  methods: {
    getAlerts () {
      this.loading = true
      this.dialog = false
      this.$http.get('/admin/alerts')
        .then(response => {
          this.alerts = this.keysToCamelCase(response.data).map(alert => {
            alert.activeStr = alert.active ? 'Aktivní' : 'Deaktivováno'
            switch (alert.type) {
              case 0: alert.typeStr = 'Info'; break
              case 1: alert.typeStr = 'Upozornění'; break
              default: alert.typeStr = 'Výstraha'; break
            }
            return alert
          })
          this.loading = false
        })
        .catch(err => console.log(err))
    },
    editAlert (alert) {
      this.editedItem = Object.assign({}, alert)
      this.dialog = true
    },
    toggleActive (item) {
      item.active = !item.active
      this.$http.patch(`/admin/alerts/${item.id}`, this.keysToSnakeCase(item))
        .then(response => {
          this.getAlerts()
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  created () {
    this.getAlerts()
  }
}
</script>

<style scoped>

</style>
